module.exports = {
  language: {
    name: '简体中文',
    title: '选择语言',
    subList: [
      {
        name: 'English',
        link: 'en',
      },
      // {
      //   name: '简体中文',
      //   link: 'zh',
      // },
      {
          name: '繁體中文',
          link: 'tw',
      },
      {
        name: '日本語',
        link: 'jp',
      },
      {
        name: '한국어',
        link: 'kr',
      },
      {
        name: 'ไทย',
        link: 'th',
      },
      {
        name: 'Tiếng Việt',
        link: 'vn',
      },
      {
        name: 'Español',
        link: 'es',
      },
    ]
  },
  "user":{//ของฉัน
    "wdtd": "ทีมของฉัน",
    "wdyj": "การแสดงของฉัน",
    "เรน": "คน",
  },
  "kjsy": {
    "title": "รายได้",
    "fxsy": "ส่วนแบ่งรายได้",
    "zjlsl": "จำนวนรางวัลทั้งหมด:",
    "jl": "รางวัล",
    "sj": "วันที่",
    "sl": "ปริมาณ",
    "sm": "คำอธิบาย"
  },
  "pay":{//ซื้อ
    "title": 'ซื้อเครื่องขุด',
    "gmsl": 'ปริมาณการซื้อ',
    "zf": 'การชำระเงิน',
    "kyye": 'ยอดเงินคงเหลือ',
    "kyyebz": 'ยอดเงินคงเหลือไม่เพียงพอ',
    "bztbtips": 'จำนวนการถอนที่ป้อนน้อยกว่าข้อกำหนดการถอนขั้นต่ำของสกุลเงิน',
    "bztbtips2": 'จำนวนเงินที่ถอนต้องไม่ต่ำกว่าจำนวนเงินที่ถอนขั้นต่ำ',
    "qsrjymm": 'โปรดป้อนรหัสผ่านการทำธุรกรรม 6 หลัก',
    "wxts": 'เตือนความจำ'
  },
  "chongbi": {
    "title": 'เงินฝาก',
    "lianmc": 'ประเภทโซ่',
    "scl": 'สร้างห่วงโซ่พิเศษ',
    "sy": 'รหัสส่วนตัว',
    "ewm": 'คิวอาร์โค้ด',
    "bcewm": 'บันทึกคิวอาร์โค้ด',
    "cbdz": 'ที่อยู่เงินฝาก',
    "fz": 'คัดลอก',
    "sl": 'จำนวนเงินฝาก',
    "qsrsl": 'กรุณาใส่จำนวนเงินฝาก',
    "sjczje": 'จำนวนเงินที่เติมจริง',
    "qsrsjczje": 'กรุณากรอกจำนวนเงินที่เติมจริง',
    "pzms": 'คำอธิบายใบรับรอง',
    "qsrms": 'กรุณาใส่คำอธิบาย',
    "hxz": 'ค่าแฮช',
    "qsrhxz": 'โปรดป้อนค่าแฮช',
    "pztp": 'ภาพบัตรกำนัล',
    "qscpztp": 'โปรดอัปโหลดรูปภาพใบรับรอง',
    "fzcg": 'คัดลอกสำเร็จ',
    "yhkcz": 'เติมเงินผ่านบัตรธนาคาร',
    "usdtcz": 'เติมเงิน USDT',
    "btccz": 'เติมเงิน BTC',
    "xzbz": 'เลือกสกุลเงิน',
    "sure": 'ยืนยัน',
    "ck": 'ดู',
    "tips1": "โปรดอย่าเติมสินทรัพย์ใด ๆ ที่ไม่ได้อยู่ในสกุลเงินนี้ไปยังที่อยู่ด้านบน มิฉะนั้นจะไม่สามารถเรียกสินทรัพย์กลับมาได้",
    "tips2": "1. ความเข้ากันได้กับกระเป๋าเงิน/แพลตฟอร์ม: นั่นคือ เครือข่ายได้รับการสนับสนุน หากแพลตฟอร์มเป้าหมายไม่สนับสนุนเครือข่ายการถอนเงินของคุณ สินทรัพย์จะไม่สามารถเรียกคืนได้",
    "tips3": "2. เครือข่ายเติมเงินและแพลตฟอร์มเป้าหมายเหมือนกัน หากคุณเลือกที่อยู่เป้าหมายคือเครือข่าย Ethereum แต่การเติมเงินเลือกสมาร์ทเชน TRC20 คุณอาจไม่สามารถเรียกข้อมูลสินทรัพย์ดิจิทัลของคุณได้",
    "tips4": "3. ตรวจสอบให้แน่ใจว่าที่อยู่และจำนวนเงินของคุณถูกต้องก่อนทำการชาร์จ",
    "tips5": "คำเตือน: เนื่องจากการไม่เปิดเผยตัวตนและความเป็นส่วนตัวของเครือข่ายที่ถูกบล็อก เมื่อคุณป้อนข้อมูลผิด คุณจะสูญเสียทรัพย์สินที่เกี่ยวข้อง โปรดตรวจสอบที่อยู่และปริมาณการเติมเงินของคุณอย่างระมัดระวัง"
  },
  "usdttb":{
    "title": 'ถอนเหรียญ',
    "lmc": 'ประเภทโซ่',
    "xzl": 'เลือกเชน',
    "xztbdz": 'เลือกที่อยู่ถอน',
    "qsrtbdz": 'โปรดป้อนที่อยู่ถอน',
    "tbdz": 'ที่อยู่ถอนเงิน',
    "qsrdz": 'กรุณาป้อนที่อยู่',
    "tbsl": 'จำนวนเงินที่ถอน',
    "tbsl2": 'จำนวนเงินที่ถอน:',
    "qsrtbsl": 'กรุณากรอกจำนวนเงินที่ถอน',
    "sjtxje": 'จำนวนเงินที่ถอนจริง',
    "qsrsjtxje": 'โปรดป้อนจำนวนเงินที่ถอนจริง',
    "dzje":'จำนวนเงินที่ได้รับ',
    "jymm": 'รหัสผ่านการทำธุรกรรม',
    "qsrjymm": 'โปรดป้อนรหัสผ่านการทำธุรกรรม',
    "sxf": 'ค่าธรรมเนียมการจัดการ',
    "qsrsxf": 'กรุณาป้อนค่าธรรมเนียมการจัดการ',
    "dzsl": 'จำนวนเงินในบัญชี',
    "dzsl2": 'จำนวนบัญชีที่ได้รับ:',
    "qsrdzsl": 'กรุณากรอกจำนวนเงินในบัญชี',
    "wxts": 'เตือนความจำ:',
    "mrzdtxcs": 'จำนวนเงินขั้นต่ำในการถอนแต่ละครั้ง:',
    "hxxf": 'ต้องการบริโภค',
    "cktx": 'ถอนได้เท่านั้น',
    "ci": 'ครั้ง',
    "wddtxyq": 'ไม่เป็นไปตามข้อกำหนดการถอน',
    "tjcg": 'การส่งสำเร็จ โปรดรอการตรวจสอบ',
    "tips": 'คุณสามารถถอนเหรียญได้ก็ต่อเมื่อพลังการประมวลผลของคุณเองมากกว่า 1T (ยกเว้นพลังการประมวลผลของเครื่องขุดประสบการณ์) หรือพลังการประมวลผลภายใต้ร่มนั้นมากกว่า 50T ',
    "dz": 'ที่อยู่',
    "qd": 'ตกลง',
    "zdtb": "การถอนขั้นต่ำ",
  },
  "kefu": {
    "title":'ติดต่อฝ่ายบริการลูกค้า',
    "zxkf":'ติดต่อฝ่ายบริการลูกค้า',
    "fzcg":'คัดลอกสำเร็จ'
  },
  "xgdlmm":{// แก้ไขรหัสผ่านเข้าสู่ระบบ
    "title":'เปลี่ยนรหัสผ่านเข้าสู่ระบบ',
    "t1":'รหัสผ่านเข้าสู่ระบบปัจจุบัน',
    "t2":'กรุณาป้อนรหัสผ่านเข้าสู่ระบบปัจจุบัน',
    "t3":'รหัสผ่านใหม่',
    "t4":'กรุณาป้อนตัวเลขและตัวอักษร 6-16 ตัว',
    "t5":'ยืนยันรหัสผ่าน',
    "t6": 'กรุณาป้อนตัวเลขและตัวอักษร 6-16 ตัว',
    "t7":'ยืนยัน',
    "t8":'รหัสผ่านไม่สอดคล้องกับรหัสผ่านยืนยัน'
  },
  "sztxmm":{// ตั้งรหัสผ่านการถอน
    "title":'เปลี่ยนรหัสผ่านการทำธุรกรรม',
    "wjtkmm": 'ลืมรหัสผ่านการทำธุรกรรม',
    "qsrjdlmm":'โปรดป้อนรหัสผ่านการทำธุรกรรมปัจจุบัน',
    "zh": 'บัญชี',
    "qsryxhzsj": 'โปรดป้อนที่อยู่อีเมลหรือโทรศัพท์มือถือ',
    "t1":'รหัสผ่านธุรกรรมปัจจุบัน',
    "t2":'รหัสผ่านการทำธุรกรรมใหม่',
    "t3":'โปรดป้อนรหัสผ่านการทำธุรกรรม 6 หลัก',
    "t4":'ยืนยันรหัสผ่าน',
    "t5":'ลืมรหัสผ่านการทำธุรกรรม? ',
    "t6":'ยืนยัน',
    "t7": 'รหัสผ่านไม่สอดคล้องกับรหัสผ่านยืนยัน',
    "t8":'รหัสผ่านการทำธุรกรรม',
    "yzm": 'รหัสยืนยัน',
    "qsryzm": 'โปรดป้อนรหัสยืนยัน',
    "hqyzm": 'รับรหัสยืนยัน'
  },
  "record": {
    "cbjl": 'บันทึกการฝากเหรียญ',
    "tbjl": 'บันทึกการถอน',
    "status":"['ยังไม่ได้ตรวจสอบ', 'ผ่าน', 'ถูกปฏิเสธ']",
    "bhly": 'เหตุผลในการปฏิเสธ',
    "ldz": 'ที่อยู่:',
    "cjsj": 'เวลาสร้าง:',
    "zzsj": 'เวลาโอน:',
    "czl": 'ห่วงโซ่การเติมเงิน:',
    "zrl": 'ห่วงโซ่การโอนย้าย:',
    "jyhx": 'แฮชธุรกรรม:'
  },
  "yqm": {
    "wdyqlj": 'ลิงก์คำเชิญของฉัน',
    "wdyqm": 'รหัสเชิญของฉัน',
    "schbyq": 'สร้างคำเชิญโปสเตอร์',
    "bctp": 'บันทึกรูปภาพ',
    "qx": 'ยกเลิก',
    "fx": 'แบ่งปัน',
    "yqm": 'คัดลอกรหัสเชิญ',
    "bcewmdxc": 'บันทึกรหัส QR ลงในอัลบั้มรูป',
    "bcbd": 'บันทึกในเครื่อง'
  },
  "wdtd": {
    "title": 'ทีมของฉัน',
    "td": 'ทีม',
    "yqhy": 'เชิญเพื่อน',
    "ren": 'บุคคล',
    "wdtdzrs": 'จำนวนทีมทั้งหมดของฉัน',
    "uid": 'uid:',
    "zh": 'บัญชี:',
    "tdrs": 'ขนาดทีม:',
    "zcsj": 'วันที่ลงทะเบียน:'
  },
  "wdyj": {
    "title": 'การแสดงของฉัน',
    "wdyd": 'รุ่นของฉัน',
    "dyj": 'ประสิทธิภาพ',
    "tdzyj": 'ประสิทธิภาพโดยรวมของทีม',
    "uid": 'uid:',
    "tdrs": 'ขนาดทีม:',
    "yj": 'ประสิทธิภาพ:'
  },
  "zc": {
    "title": 'เนื้อหา',
    "zzczh": 'สินทรัพย์รวมเทียบเท่า',
    "dh": 'แลกเปลี่ยน',
    "yczc": 'ทรัพย์สินที่ถูกซ่อนเป็น 0',
    "xj": 'ราคาปัจจุบัน',
    "zh": 'แปลงแล้ว',
    "zcmx": 'รายละเอียดสินทรัพย์',
  },
  "duihuang": {
    "title": 'การแลกเปลี่ยน',
    "hl": 'อัตราแลกเปลี่ยน',
    "zf": 'การชำระเงิน',
    "qbdh": 'แลกเปลี่ยนทั้งหมด',
    "ky": 'ว่าง',
    "dd": 'รับ',
    "ljdh": 'แลกทันที',
    "cont": 'การเปลี่ยนแปลงอัตราแลกเปลี่ยน ขึ้นอยู่กับจำนวนเงินจริงที่ได้รับ',
    "yebz": 'ยอดเงินไม่เพียงพอ',
    "ksslbz": 'มีปริมาณไม่เพียงพอ',
    "qtxje": 'กรุณาใส่จำนวน',
    "dhcg": 'แลกเปลี่ยนสำเร็จ',
    "mrcg": 'ซื้อสำเร็จ',
    "mccg": 'ขายสำเร็จ',
    "wtcg": 'การมอบหมายสำเร็จ',
    "ts": 'พรอมต์',
    "btcmTips": 'ตามการตั้งค่าสัญญาอัจฉริยะ การแลกเปลี่ยน GDCC USDT จะเริ่มในวันที่ 8 สิงหาคม 2023 ',
    "qx": 'ยกเลิก'
  },
  "sign": {
    "title": 'ลงชื่อเข้าใช้เพื่อรับเหรียญ',
    "title2": 'รางวัลการลงชื่อเข้าใช้รายวัน',
    "title3": 'รางวัลการลงชื่อเข้าใช้',
    "qd": 'ลงชื่อเข้าใช้',
    "yqd": 'ลงชื่อเข้าใช้',
    "hdgz": 'กฎกิจกรรม',
    "qdjl": 'บันทึกการเช็คอิน',
    "qdcg": 'ลงชื่อเข้าใช้สำเร็จ'
  },
  "langNew": {
    "wd": "ของฉัน",
    "jd": "การยืม",
    "jghy": "ฟิวเจอร์ส",
    "xbsg": "การซื้อสกุลเงินสิงคโปร์",
    "sylx": "ประเภทสิทธิประโยชน์",
    "syts": "วันที่มีรายได้: ",
    "rsy": "รายได้รายวัน: ",
    "rsy2": "รายได้รายวัน",
    "yjdts": "จำนวนวันที่ยืม: ",
    "jdsy": "รายได้จากการให้กู้ยืม:  ",
    "jdsy2": "รายได้จากการให้กู้ยืม",
    "jdrq": "วันที่ยืม:",
    "qdsy": "สิทธิประโยชน์ในการลงชื่อเข้าใช้",
    "tgsy": "สิทธิประโยชน์จากโปรโมชัน",
    "sybl": "อัตราส่วนกำไร",
    "sybl2": "อัตราส่วนกำไร: ",
    "ljcy": "เข้าร่วมทันที",
    "zsy": "รายได้รวม",
    "jdrz": "โหนดลิงก์",
    "jiedian": "โหนด",
    "qsrje": "โปรดป้อนโหนด",
    "xyb": "ถัดไป",
    "zhye": "ยอดคงเหลือในบัญชี",
    "dzye": "ที่อยู่คงเหลือ",
    "zhyezh": "ยอดคงเหลือในบัญชี (เทียบเท่า)",
    "zq": "ระยะเวลา: ",
    "zq2": "จุด",
    "jdsl": "จำนวนเงินกู้",
    "yxbd": "ยืนยันอีเมล",
    "qsryxzh": "กรุณากรอกบัญชีอีเมลของคุณ",
    "yxgz": "ที่อยู่อีเมลที่ป้อนไม่เป็นไปตามกฎ",
    "jxz": "กำลังดำเนินการ",
    "ywc": "เสร็จสมบูรณ์",
    "day": "วัน",
    "jg": "ราคา: ",
    "zwsj": "ไม่มีข้อมูล~",
    "wyjb": "ยืม",
    "fxjl": "แบ่งปันรางวัล",
    "aqsz": "การตั้งค่าความปลอดภัย",
    "wded": "รุ่นที่สองของฉัน",
    "wdsd": "สามรุ่นของฉัน",
    "dbxe": "จำกัดการทำธุรกรรมเดี่ยว",
    "tjdd": "ส่งคำสั่งซื้อ",
    "tqsh": "ถอนการไถ่ถอน: ",
    "shuhui": "การไถ่ถอน",
    "ljdz": "ที่อยู่ลิงก์",
    "yyqh": "เปลี่ยนภาษา",
    "zxkf": "ฝ่ายบริการลูกค้า",
    "syl": "ส่งคืนรายวัน",
    "zhuanbi": "รับเหรียญ",
    "zbsy": "รับรายได้เป็นสกุลเงิน",
    "mc": "ชื่อ",
    "zxj": "ราคาล่าสุด",
    "zfb": "รายการที่กำลังมาแรง",
    "shouye": "หน้าแรก",
    "gg": "ประกาศ",
    "rzz": "กำลังรับรอง",
    "yrz": "รับรองความถูกต้อง",
    "rzsb": "การรับรองความถูกต้องล้มเหลว โปรดตรวจสอบความถูกต้องอีกครั้ง",
    "cxrz": "การรับรองความถูกต้องอีกครั้ง",
    "jymmts": "โปรดไปที่การตั้งค่าความปลอดภัยเพื่อตั้งรหัสผ่านการทำธุรกรรม"
  },
  "xbsg":{
    "title": "เหรียญใหม่",
    "wdsg": "รายละเอียด",
    "scts": "วันกักตัว: ",
    "sy": "ที่เหลืออยู่",
    "ljsg": "สมัครสมาชิกตอนนี้",
    "ysk": "ขายหมดแล้ว",
    "xzjdy": "สมัครสมาชิกตอนนี้",
    "dy": "ติดตาม",
    "fxjg": "ออกราคา",
    "fxl": "การไหลเวียน",
    "ssrq": "วันที่ลงรายการ",
    "yxqx": "ระยะเวลาที่ใช้ได้",
    "qsrsl": "กรุณาระบุจำนวนเงิน",
    "syl": "ที่เหลืออยู่",
    "sgrq": "ติดตาม",
    "sgsl": "จำนวน",
    "bz": "เหรียญ",
    "yebz": "ยอดเงิน USDT ไม่เพียงพอ",
    "tgsl": "ผ่านจำนวน",
    "shz": "ภายใต้การทบทวน",
    "wtg": "ไม่ผ่าน",
    "ytg": "ผ่านไป"
  },
  "wydb":{
    "title": "ยืม",
    "db": "ยืม",
    "dbz": "ยืม",
    "jl": "บันทึก",
    "jdzq": "ระยะเวลา (วัน)",
    "qhk": "เพื่อชำระคืน",
    "ljdb": "สะสม",
    "dhkbs" :"ที่รอดำเนินการชำระเงิน",
    "jkje": "วงเงินกู้",
    "qsrje": "กรุณาระบุจำนวนเงิน",
    "rll": "อัตราดอกเบี้ยรายวัน",
    "hkfs": "การชำระคืน",
    "dqych": "หมดอายุ",
    "lx": "ความสนใจ",
    "fkjg": "ผู้ให้กู้",
    "tpsc": "สินเชื่อเงินกู้ (อัพโหลดรูปภาพ)",
    "fwxx": "ข้อมูลที่อยู่อาศัย",
    "srzm": "หลักฐานแสดงรายได้ (ความสัมพันธ์ในการจ้างงาน)",
    "yhmx": "รายการเงินฝากถอนในบัญชีเงินฝาก",
    "zjz": "รูปถ่ายประจำตัว",
    "yd": "ฉันได้อ่านและตกลง",
    "xy": "สมัครสัญญาเงินกู้",
    "sqdb": "สมัครกลุ่มสินเชื่อ",
    "gb": "ปิด",
    "qd": "ตกลง",
    "ts": "โปรดตรวจสอบ สมัครสัญญาเงินกู้",
    "dbjl": "บันทึก",
    "hkhth": "รหัสการสั่งซื้อ",
    "wsh": "ยังไม่ได้ตรวจสอบ",
    "yfk": "เงินกู้",
    "sqrq": "เวลาสมัคร",
    "zq": "วงจร",
    "dbsl": "จำนวนซี่โครง",
    "zhke": "การชำระเงินทั้งหมด",
    "yhkxq": "รายละเอียดการชำระคืน",
    "bqyhk": "ชำระคืนในงวดปัจจุบัน(USDT)",
    "hktips": "กรุณาตรวจสอบให้แน่ใจว่ายอดเงินคงเหลือเพียงพอ หากยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วจึงค่อยชำระคืน",
    "bj": "อาจารย์ใหญ่",
    "jie": "ยืม",
    "ljhk": "ชำระคืนทันที",
    "qcz": "การฝาก",
    "yebzqxcz": "ยอดเงินไม่เพียงพอ กรุณาเติมเงินก่อนแล้วค่อยชำระคืน",
    "znj": "ค่าธรรมเนียมการชำระล่าช้า",
    "yqts": "วันที่เกินกำหนด"
  },
  "hkxq":{
    "dd":"คำสั่ง",
    "fzhkdz":"คัดลอกที่อยู่การชำระเงิน",
    "hkxq": "รายละเอียดการชำระคืน",
    "zlx": "ดอกเบี้ยทั้งหมด",
    "zhk": "ชำระคืนทั้งหมด",
    "hkjg": "หน่วยงานการชำระคืน",
    "hkpz": "ใบรับรองการชำระหนี้"
  },
  "kxt": {
    "gao":"H",
    "di":"L",
    "wtgd": "มอบหมายที่รอดำเนินการ",
    "cj": "ดีล",
    "jj": "บทนำ",
    "sj": "เวลา",
    "fx": "ทิศทาง",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "mr": "ซื้อเข้า",
    "mc": "ขายออก",
    "mp": "คำสั่งซื้อ",
    "sp": "คำสั่งขาย",
    "slb": "ปริมาณ",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "yue": "เดือน",
    "ft": "ภาพรอง",
    "zt": "ภาพหลัก",
    "sdt": "แผนที่ความลึก",
    "zx": "เลือกเอง",
    "djck": "คลิกเพื่อดู"
  },
  "jghy": {
    "jghy": "อนาคต",
    "yxhy": "สัญญาถาวร",
    "mz": "ซื้อขึ้น",
    "md": "ซื้อลง",
    "gmj": "ราคาซื้อ",
    "jsj": "ราคาชำระ",
    "xj": "ราคาปัจจุบัน",
    "fx": "ทิศทาง",
    "sl": "ปริมาณ",
    "jgsj": "เวลาจัดส่ง",
    "gb": "ปิดตัวลง",
    "jxxd": "สั่งซื้อต่อ",
    "cclb": "รายชื่อตำแหน่ง",
    "zc": "ถืออยู่",
    "lscc": "ประวัติการถือ",
    "qblx": "ทุกประเภท",
    "yk": "กำไรขาดทุน",
    "ddqr": "ยืนยันการสั่งซื้อ",
    "dqsj": "วันที่ครบอายุ",
    "jssj": "เวลาตัดบัญชี",
    "sy": "รายได้",
    "tzje": "จำนวนเงินลงทุน",
    "zdje": "จำนวนเงินลงทุนมากกว่า 0",
    "kyye": "สมดุล",
    "kyye2": "สมดุล: ",
    "sxf": "ค่าธรรมเนียม: ",
    "sxfl": "ค่าธรรมเนียม",
    "jypz": "ประเภทการซื้อขาย",
    "jyfx": "ทิศทางการซื้อขาย",
    "qrxd": "ยืนยันสั่งซื้อ",
    "dqye": "ยอดคงเหลือ"
  },
  "zhjl": {
    "title": "ประวัติสินทรัพย์",
    "cbtb": "ฝากและถอน",
    "jymx": "ประวัติการทำรายการ",
    "tgyj": "ค่าคอมมิชชั่นโปรโมชั่น",
    "wwc": "ยังไม่สำเร็จ",
    "ywc": "สำเร็จ"
  },
  "tipsNew":{
    "wjmmts": "กู้คืนรหัสผ่านด้วยรหัสยืนยัน",
    "qscpztp": "อัพโหลดภาพบัตรกำนัล",
    "emailgsts": "กรุณาใส่อีเมลที่ถูกต้อง",
    "telgsts": "หมายเลขโทรศัพท์มือถือไม่ถูกต้อง",
    "lcmmbyz": "กรุณายืนยันรหัสผ่านของคุณ",
    "zdsl": "จำนวนขั้นต่ำ ",
    "sldydy": "ปริมาณที่มากกว่าหรือเท่ากับ",
    "zxtzsl": "จำนวนขั้นต่ำ ",
    "ddz": "ที่รอ",
    "xs": "ชั่วโมง",
    "min": "จำนวนขั้นต่ำ ",
    "max": "จำนวนสูงสุด ",
    "yebz": "ยอดเงินไม่เพียงพอ",
    "qsrss": "กรุณาใส่ล็อต",
    "zdss": "ล็อตขั้นต่ำ",
    "yjj": "ถูกปฏิเสธ",
    "shz": "การไถ่ถอน",
    "zwkfcz": "สกุลเงินนี้ยังไม่เปิดให้เติมเงิน",
    "jiaoge": "เดลิเวอรี่",
    "zhang": "ซื้อ",
    "die": "ขาย",
  },
  "assets": {
    "total": "การแปลงสินทรัพย์",
    "avaiable": "ว่าง",
    "conversion": "การแปลง",
    "canuse": "ใช้ได้",
    "yczc":"เนื้อหาถูกซ่อนเป็น 0"
  },
  "status": {
    "statusText": ['ล้มเหลว','กำลังรอ','สำเร็จ'],
  },
  "langNew2":{
    "zczgz": "สินทรัพย์รวม",
    "hgx": "การปฏิบัติตาม",
    "yszc": "นโยบายความเป็นส่วนตัว",
    "gywm": "เกี่ยวกับเรา",
    "zb": "ปริมาณ AI",
    "mnjy": "การซื้อขายจำลอง",
    "xbzq": "โซนสกุลเงินสิงคโปร์",
    "flzq": "ศูนย์กลางของรางวัล",
    "cjmnzhcg": "สร้างบัญชีทดลองสำเร็จ!",
    "wdzh": "บัญชีของฉัน",
    "yymnzhts": "มีบัญชีเสมือนอยู่แล้ว โปรดอย่าลงทะเบียนอีก",
    "tcmnzh": "ออกจากบัญชีทดลอง",
    "mnzhgz": "การประเมินมูลค่าบัญชีทดลอง",
    "mnzh": "บัญชีทดลอง",
    "ljdzsb": "ไม่สามารถเชื่อมต่อกับที่อยู่",
    "ysq": "ได้รับอนุญาต"
  },
  "c2c":{
    "bt": "P2P",
    "bt2": "บริการชำระเงิน P2P",
    "cjdd": "สร้างคำสั่งซื้อ",
    "mblc": "เงินฝากสกุลเงินคำสั่ง",
    "cjydd": "สร้างการสั่งซื้อล่วงหน้า",
    "xmjfk": "ชำระเงินให้กับผู้ขาย",
    "tqhb": "ถอนสกุลเงินดิจิทัลของคุณ",
    "ddzt": "สถานะการสั่งซื้อ",
    "wdys": "ข้อดีของเรา",
    "c1": "ซื้อขายในราคาที่คุณต้องการ",
    "c2": "ซื้อและขายสกุลเงินดิจิทัลได้อย่างอิสระในราคาที่คุณต้องการ ซื้อและขายจากข้อเสนอที่มีอยู่ หรือสร้างโฆษณาการค้าเพื่อกำหนดราคาในอุดมคติของคุณ",
    "c3": "ค่าธรรมเนียมการทำธุรกรรมต่ำ",
    "c4": "ธุรกรรมแบบ Peer-to-peer (P2P) ช่วยให้ผู้ขายกำหนดวิธีการชำระเงินที่พวกเขาต้องการได้อย่างอิสระในวิธีที่โปร่งใส ซื้อและขายสกุลเงินดิจิทัลผ่านวิธีการชำระเงินมากกว่า 700 วิธี รวมถึงการโอนเงินผ่านธนาคารและเงินสด",
    "c5": "วิธีการชำระเงินหลายวิธี",
    "c6": "การซื้อขายแบบ Peer-to-peer (P2P) ช่วยให้ผู้ขายกำหนดวิธีการชำระเงินที่พวกเขาต้องการได้อย่างอิสระ ซื้อและขายสกุลเงินดิจิทัลด้วยวิธีการชำระเงินมากกว่า 700 วิธี รวมถึงการโอนเงินผ่านธนาคาร เงินสด",
    "wpp": "ไม่ตรงกัน",
    "ypp": "ตรงกัน",
    "ysx": "หมดอายุ",
    "ddh": "หมายเลขคำสั่งซื้อ",
    "mrje": "ซื้อจำนวน",
    "mrbz": "ซื้อสกุลเงิน",
    "nssdgj": "ประเทศ",
    "qsrnssdgj": "กรุณาระบุประเทศ",
    "fkrxm": "ชื่อผู้ชำระเงิน",
    "qsrfkrxm": "กรุณากรอกชื่อผู้ชำระเงิน",
    "yx": "อีเมล",
    "qsryx": "กรุณากรอกที่อยู่อีเมลของคุณ",
    "mmbz": "ประเภทการซื้อ",
    "qxzmmbz": "โปรดเลือกประเภทการซื้อ",
    "qxz": "กรุณาเลือก",
    "fkfs": "วิธีการชำระเงิน",
    "qtxfkfs": "กรุณากรอกวิธีการชำระเงิน",
    "zh": "บัญชี",
    "fb": "ประเภทสกุลเงินการชำระเงิน",
    "qtxfb": "กรุณากรอกประเภทสกุลเงินสำหรับการชำระเงิน",
    "ngmdje": "จำนวนการซื้อของคุณ",
    "qsrje": "กรุณากรอกจำนวนเงิน",
    "wxts": "คำเตือนที่อบอุ่น:",
    "dsh": "ต้องได้รับการตรวจสอบ",
    "ygq": "หมดอายุ",
    "jcwdwt": "ความรู้เบื้องต้นเกี่ยวกับ P2P",
    "tjpz": "ส่งบัตรกำนัล",
    "ckje": "จำนวนที่ตรงกัน",
    "qsrckje": "กรุณากรอกจำนวนเงินที่ตรงกัน",
    "tjzzfb": "โอนสำเนา",
    "tjjzzm": "บัตรประจำตัวประชาชน (ด้านหน้า)",
    "tjjzfm": "บัตรประจำตัวประชาชน (ด้านหลัง)",
    "psts1": "โปรดใส่ใจกับประเด็นต่อไปนี้เมื่อถ่ายภาพ",
    "psts2": "โปรดทราบว่าขอบของรูปภาพสมบูรณ์ แบบอักษรชัดเจน และความสว่างสม่ำเสมอ",
    "psts3": "โปรดอย่าอัปโหลดรูปถ่ายติดบัตรที่ไม่ตรงกับชื่อของคุณ",
    "qsczzfb": "โปรดอัปโหลดสำเนาการโอน",
    "qscjzzm": "โปรดอัปโหลดด้านหน้าใบขับขี่ของคุณ",
    "qscjzfm": "โปรดอัปโหลดด้านหลังใบขับขี่ของคุณ",
    "tj": "ส่ง",
    "je": "ช่วงจำกัด",
    "ljtg": "สั่งซื้อ",
    "sp": "ทำความเข้าใจ DeFi",
    "xq": "รายละเอียด",
    "lxkfppdd": "ติดต่อฝ่ายบริการลูกค้าเพื่อให้ตรงกับคำสั่งซื้อ",
    "szgj": "ประเทศ",
    "qsrszgj": "กรุณาระบุประเทศของคุณ",
    "fkyhmc": "ชื่อธนาคารสำหรับชำระเงิน",
    "qsrfkyhmc": "โปรดป้อนชื่อธนาคารที่ชำระเงิน",
    "dianhui": "โอนเงิน/โอนเงินระหว่างประเทศ",
    "ccsr": "ป้อนที่นี่"
  },
  "xyf":{
    "title": "คะแนนเครดิต",
    "pgsj": "เวลาประเมิน"
  },
  "bbjy": {
    "mr": "ซื้อเข้า",
    "mc": "ขายออก",
    "mai": "ซื้อ",
    "sell": "ขาย",
    "xj": "ขีดจำกัด",
    "sj": "ราคาตลาด",
    "pk": "แฮนดิแคป",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "mrl": "ยอดซื้อเข้า",
    "ss": "ปริมาณ",
    "mcl": "ปริมาณขายออก",
    "ky": "ใช้ได้",
    "km": "ซื้อได้",
    "ksell": "พร้อมขาย",
    "jye": "ยอดที่ทำรายการ",
    "dqwt": "คำสั่งซื้อปัจจุบัน",
    "lswt": "ค่าคอมมิชชั่นอดีต",
    "jj": "บทนำ",
    "wtzl": "รวม",
    "wtjg": "ราคาคอมมิชชั่น",
    "ycjl": "ปริมาณ",
    "cjjj": "ราคาซื้อขายเฉลี่ย",
    "cd": "ยกเลิกคำสั่งซื้อ",
    "xd": "สั่งซื้อ",
    "ywc": "สำเร็จ",
    "ycd": "ยกเลิกคำสั่งซื้อ",
    "wqcj": "เสร็จสมบูรณ์",
    "zx": "เลือกเอง",
    "scjg": "ราคาตลาด",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "qx": "ยกเลิก",
    "bbjy": "ธุรกรรมสกุลเงิน"
  },
  "hyjy": {
    "mai": "ซื้อ",
    "sell": "ขาย",
    "kc": "เปิดการขาย",
    "pc": "คัทลอส ",
    "cc": "ถือเหรียญ",
    "kp": "ปิด",
    "kpc": "ปิดระยะสั้น",
    "kcc": "ตำแหน่งที่ถือได้",
    "kkd": "เปิดระยะยาว",
    "kpd": "ปิดระยะยาว",
    "kkk": "เปิดสั้น",
    "xj": "ขีดจำกัด",
    "sj": "ราคาตลาด",
    "xjwt": "จำกัดคำสั่งซื้อ",
    "sjwt": "คำสั่งของตลาด",
    "pk": "แฮนดิแคป",
    "jg": "ราคา",
    "sl": "ปริมาณ",
    "gg": "เลเวอเรจ",
    "tzgg": "ปรับเลเวอเรจ",
    "ggbs": "เลเวอเรจเท่าตัว",
    "mrl": "ยอดซื้อเข้า",
    "ky": "ใช้ได้",
    "jye": "ยอดที่ทำรายการ",
    "dqwt": "คำสั่งซื้อปัจจุบัน",
    "lswt": "ค่าคอมมิชชั่นอดีต",
    "ptwt": "คำสั่งซื้อทั่วไป",
    "dqwtmr": "คำสั่งซื้อปัจจุบัน (ซื้อเข้า)",
    "dqwtmc": "คำสั่งซื้อปัจจุบัน (ขายออก)",
    "hywt": "สัญญาคำสั่งซื้อ",
    "jj": "บทนำ",
    "wtzl": "รวม",
    "wtjg": "ราคาคอมมิชชั่น",
    "ycjl": "ปริมาณ",
    "cjjj": "ราคาซื้อขายเฉลี่ย",
    "cd": "ยกเลิกคำสั่งซื้อ",
    "xd": "สั่งซื้อ",
    "wqcj": "เสร็จสมบูรณ์",
    "ywc": "สำเร็จ",
    "ycd": "ยกเลิกคำสั่งซื้อ",
    "zx": "เลือกเอง",
    "scjg": "ราคาตลาด",
    "fhsj": "เวลาเปิดขาย",
    "fhsl": "จำนวนเปิดขาย",
    "bps": "กระดาษสีขาว",
    "gw": "เว็บไซต์อย่างเป็นทางการ",
    "mrzd": "ซื้อนาน",
    "mrpk": "ซื้อสั้น",
    "mczk": "ขายระยะสั้น",
    "mcpd": "ขายระยะยาว",
    "mrkdkz": "ซื้อเปิดยาว (ขาขึ้น)",
    "mrpkkz": "ซื้อชอร์ต (ขาขึ้น)",
    "mckkkd": "ขาย open short (ขาลง)",
    "mcpdkd": "ขายทรงตัวยาว (ขาลง)",
    "yxhy": "สัญญาถาวร",
    "dc": "หลายตำแหน่ง",
    "syl": "อัตราผลตอบแทน",
    "bzjl": "อัตราเงินประกัน",
    "tzbzj": "ปรับเงินประกัน",
    "zyzs": "ทำกำไร และหยุดการสูญเสีย",
    "zhang": "ปริมาณ",
    "qblx": "ทุกประเภท",
    "qb": "ทั้งหมด",
    "ccjg": "ราคาตำแหน่ง",
    "ccsl": "จำนวนตำแหน่ง",
    "yk": "กำไรขาดทุน",
    "ccsj": "เวลาถือ",
    "zy": "ทำกำไร",
    "zs": "หยุดการสูญเสีย",
    "zje": "ยอดรวม",
    "kcs": "จำนวนตำแหน่งที่เปิดรับ",
    "kcjg": "ราคาเปิด",
    "ss": "ล็อต",
    "hand": "1 ล็อต =",
    "qx": "ยกเลิก",
    "qr": "ยืนยัน",
    "qbcd":"ยกเลิกคำสั่งซื้อทั้งหมด"
  },
  "bbjyNew":{
    "jylx": "ชนิดของ",
    "jyze": "จำนวน"
  },
  "langNew3":{
    "bzxq": "รายละเอียดการเคลื่อนย้ายอิฐ",
     "znbz": "การเคลื่อนย้ายอิฐอัจฉริยะเชิงปริมาณ AI",
     "apits": "เชื่อมต่อกับ API ของการแลกเปลี่ยนมากกว่า 200 แห่งทั่วโลกได้อย่างราบรื่น",
     "jr": "เข้าร่วม",
     "gn": "ฟังก์ชัน",
     "lhjs": "ความรู้เบื้องต้นเกี่ยวกับปริมาณเงินปันผล",
     "jqrts": "โรบ็อตทำงานอย่างไร",
     "sctj": "สถิติตลาด",
     "scqk": "สภาวะตลาด",
     "jiaoge": "จัดส่ง",
     "zhang": "ลุกขึ้น",
     "die": "ล้ม",
     "sz": "การตั้งค่า",
     "qbcp": "ผลิตภัณฑ์ทั้งหมด",
     "jrlh": "เข้าร่วมการวัดปริมาณ AI",
      "sywd": "0 ความเสี่ยง ผลตอบแทนที่มั่นคง",
      "bzbz": "ประเภทการเข้ารหัสลับ"
  },
  "sztkmm": {
    "title": "ตั้งรหัสผ่านการทำธุรกรรม",
    "dlmm": "ใส่รหัสผ่าน",
    "dlmmts": "โปรดใส่รหัสผ่านของคุณ",
    "xmm": "รหัสผ่านใหม่",
    "mmts": "ความยาวรหัสผ่าน 6 หลัก",
    "qrmm": "ยืนยันรหัสผ่าน",
    "qr": "ยืนยัน",
    "qd": "ตกลง",
    "sztkts": "เคล็ดลับ: โปรดไปตั้งรหัสผ่านการทำธุรกรรมที่ศูนย์ความปลอดภัย"
  },
  "bzhl": {
    "title": "เงินปันผล",
    "gz": "กฎ",
    "tgdd": "คำสั่งเอสโครว์",
    "zztgdzj": "กองทุนที่อยู่ในความดูแล",
    "yjjrsy": "ประมาณการรายวัน",
    "ljsy": "รายได้ทั้งหมด",
    "tgzdd": "คำสั่งอยู่ในความดูแล",
    "cljxcp": "ผลิตภัณฑ์แคมเปญเชิงกลยุทธ์ ",
    "dbxe": "ขีดจำกัด",
    "rsyl": "อัตราผลตอบแทนรายวัน",
    "zq": "รอบการสั่งซื้อ ",
    "qmr":"ไปซื้อเลย",
    "bbzhzc": "สินทรัพย์ของบัญชี",
    "zcc": "สินทรัพย์รวม (USDT)",
    "dd": "คำสั่งซื้อ",
    "buy": "ซื้อใน",
    "jxcp": "ผลิตภัณฑ์แนะนำ",
    "ckdd": "ตรวจสอบคำสั่งซื้อ",
    "gd": "เพิ่มเติม",
    "xzbzts": "ง่ายและปลอดภัย สามารถเลือกจ่ายเงินปันผลได้หลายสกุลเงิน",
    "qtbz": "เหรียญอื่นๆ",
    "dj": "ระดับ",
    "cjwt": "ปัญหาทั่วไป",
    "ddsl": "ปริมาณการสั่งซื้อ",
    "sl": "จำนวน"
  },
  "bzhlgm": {
    "qtzq": "USDT รอบ 7 วัน",
    "rsyl": "อัตราผลตอบแทนรายวัน (%)",
    "lczq": "การเงินรายสัปดาห์",
    "dbxe": "จำกัดยอดเดียว ",
    "pxsj": "เวลาปันผล",
    "mr": "ทุกวัน",
    "dqfh": "ผลตอบแทนเมื่อครบกำหนด",
    "tgzj": "ทุนการดูแล",
    "tqsh": "รับการไถ่ถอน",
    "yjsy": "ผลตอบแทนโดยประมาณ (USDT)",
    "kyzc": "สินทรัพย์ที่มีอยู่ (USDT)",
    "cpjs": "รายละเอียดสินค้า",
    "tgje": "ยอดเงินการดูแล",
    "qsrtgje": "โปรดใส่ยอดเงินการดูแล",
    "qb": "ทั้งหมด",
    "rm": "คลิกที่นี่",
    "cpzq": "อายุผลิตภัณฑ์",
    "gz": "เข้าใจกฎและสิทธิ์"
  },
  "bzhlwdtg": {
    "title": "สถานะการสั่งซื้อ",
    "tgz": "อยู่ในความดูแล",
    "ywc": "เสร็จสิ้นแล้ว ",
    "ysh": "แลกแล้ว ",
    "tgje": "จำนวนการดูแล/เวลาการดูแล",
    "rsyl": "หนูกลับรายวัน",
    "yhl": "มีกำไร",
    "xdsj": "เวลาสั่งซื้อ",
    "sh": "การไถ่ถอน ",
    "ddxq": "รายละเอียดการสั่งซื้อ",
    "ddh": "หมายเลขคำสั่งซื้อ ",
    "syts": "ที่เหลืออยู่",
    "ddztxq": "รายละเอียดสถานะการสั่งซื้อ"
  },
  "langNew4":{
    "kp": "เปิด",
    "zuoshou": "ได้รับเมื่อวาน",
    "zg": "สูงสุด",
    "zd": "ต่ำสุด",
    "dqjg": "ราคาปัจจุบัน",
    "pcjg": "ราคาปิด",
    "gd": "คำสั่งซื้อที่รอดำเนินการ",
    "gdj": "ราคาคำสั่งซื้อที่รอดำเนินการ",
    "gdjg": "ราคาคำสั่งซื้อที่รอดำเนินการ",
    "xfbzj": "เงินประกันที่จำเป็น: ",
    "ksrfw": "ช่วงอินพุตที่ใช้ได้: ",
    "shou": "จำนวนมาก",
    "fdjyk": "กำไรสุทธิลอยตัว",
    "pcsl": "ปริมาณการปิดบัญชี",
    "cx": "ถอน",
    "qrpc": "ยืนยันการปิดตำแหน่ง",
    "sx": "กรอง",
    "cz": "รีเซ็ต",
    "zdl": "รู้",
    "kccg": "เปิดตำแหน่งสำเร็จ!",
    "xzfx": "เลือกทิศทาง",
    "lx": "พิมพ",
    "xgcc": "แก้ไขตำแหน่ง",
    "szzyzs": "ตั้งค่าหยุดกำไรและหยุดการขาดทุน",
    "szhb": "สกุลเงินดิจิทัล",
    "gjs": "โลหะ",
    "yy": "น้ำมันดิบ",
    "jy": "ซื้อขาย",
    "gp": "คลังสินค้า",
    "jmhb": "สกุลเงินดิจิทัล",
    "gdsj": "เวลาการสั่งซื้อที่รอดำเนินการ",
    "gdsl": "จำนวนการสั่งซื้อที่รอดำเนินการ",
    "fs": "time"
   },
   "deals": {
    "issue_time": "เวลาเปิดขาย",
    "issue_number": "จำนวนเปิดขาย",
    "white_book": "กระดาษสีขาว",
    "weburl": "เว็บไซต์อย่างเป็นทางการ",
    "video_url": "วีดีโอแนะนำ",
    "introduction": "บทนำ",
    "onhand": "1 ล็อต เท่ากับ",
    "position": "ยอดที่ถือปัจจุบัน",
    "leverorder": "คำสั่งเลเวอเรจ",
    "leverposition": "ยอดเลเวอเรจ",
    "inputprice": "ใส่ราคา",
    "inputmul": "ใส่เท่าตัว",
    "selectmul": "เลือกเท่าตัว",
    "onehand": "1 ล็อต เท่ากับ",
    "hand": "ล็อตการซื้อขาย",
    "marketval": "มูลค่าตลาดตามสัญญา",
    "bond": "เงินประกัน",
    "balance": "คงเหลือ",
    "type": "ประเภท",
    "risk": "อัตราความเสี่ยง",
    "total": "กำไรและขาดทุนของยอดที่ถือทั้งหมด:",
    "onekey": "ชำระบัญชีคลิกเดียว",
    "makemore": "(ยาวไป)",
    "makeless": "(สั้น)",
    "current": "คำสั่งซื้อปัจจุบัน",
    "all": "ทั้งหมด",
    "weing": "คำสั่งที่เปิดอยู่",
    "tding": "กำลังดำเนินการ",
    "ping": "กำลังคัทลอส ",
    "pied": "คัทลอสแล้ว",
    "ceiled": "ยกเลิกคำสั่งซื้อ",
    "weprice": "ค่าธรรมเนียม",
    "oprice": "ราคาเปิด",
    "nowprice": "ราคาปัจจุบัน",
    "zyprice": "ขายทำกำไร",
    "zsprice": "ราคาคัทลอส",
    "canbond": "ยอดที่สามารถใช้ได้",
    "optime": "เวลาเปิด",
    "pgtime": "เวลาปิด",
    "znum": "ปริมาณที่แปลงแล้ว",
    "gprice": "ค่าธรรมเนียมค้างคืน",
    "pcang": "คัทลอส ",
    "revoke": "ยกเลิกคำสั่งซื้อ",
    "fee": "ค่าธรรมเนียม",
    "you": "ซื้อขายในราคาที่ดีที่สุดในปัจจุบัน"
  },
  "zyzs": {
    "title": "ทำกำไร และหยุดการสูญเสีย",
    "zy": "ทำกำไร",
    "zs": "หยุดการสูญเสีย",
    "qsrzyjg": "โปรดใส่ราคาทำกำไร",
    "qsrzsjg": "โปรดใส่ราคาหยุดการสูญเสีย",
    "scjg": "ราคาตลาด",
    "wxts": "เคล็ดลับ:",
    "qr": "ยืนยัน"
  },
  "ssbt":{
    "ssbt":"การอุดหนุนภาษี",
    "ssnhm":"หมายเลข SSN",
    "qsrssnhm":"กรุณากรอกหมายเลข SSN ของคุณ",
    "idzmz":"รูปถ่ายหน้าบัตรประชาชน",
    "qscidzmz":"กรุณาอัพโหลดรูปถ่ายด้านหน้าบัตรประจำตัวของคุณ",
    "dhfb":"สำเนาการโอนเงิน",
    "qscdhfb":"กรุณาอัพโหลดสำเนาการโอนเงินของคุณ",
    "srlyfb":"สำเนาแหล่งที่มาของรายได้",
    "qscsrlyfb":"กรุณาอัพโหลดสำเนาแหล่งที่มาของรายได้ของคุณ",
  },
  "newReg":{
    "sjh": "โทรศัพท์มือถือ",
    "yx": "อีเมล",
    "yqm": "รหัสการเชิญ",
    "yqm2": "รหัสเชิญ (ไม่บังคับ)",
    "cjzh": "สร้างบัญชี",
    "sysjhzyx": "ลงทะเบียนด้วยเบอร์มือถือ/อีเมล",
    "sj": "มือถือ",
    "yhxy": "&lt;ข้อตกลงผู้ใช้&gt;",
    "yhxy2": "ฉันได้อ่านและยอมรับและ &lt;ข้อตกลงผู้ใช้&gt; ",
    "hmyzh":"ยังไม่มีบัญชี",
    "qzc":"ลงทะเบียน",
    "qbdl": "เข้าสู่ระบบกระเป๋าเงิน",
    "qyqbfw": "โปรดใช้แอปกระเป๋าสตางค์เพื่อเข้าถึง",
    "dc": "ออกจากระบบ"
  },
  "langNew5":{
    "dl":"เข้าสู่ระบบ",
    "ljdz":"เชื่อมโยงที่อยู่กระเป๋าเงิน",
    "srdz":"ป้อนที่อยู่",
    "ljqq":"คำขอเชื่อมต่อ",
    "qq":"คำขอสำหรับ",
    "qb":"Wallte",
    "ckyehhd":"ดูยอดคงเหลือและกิจกรรมของคุณ",
    "qqjypz":"ขออนุมัติธุรกรรม",
    "cro":"Cronos",
    "jj":"ปฏิเสธ",
    "lj":"เชื่อมต่อ",
  }
}



// WEBPACK FOOTER //
// ./src/utils/lang/ty.js